import { useSignals } from '@preact/signals-react/runtime';
import { useContainer } from 'src/features/ioc';
import { useSelector } from 'src/store/hooks';

/**
 * @returns false if the user isn't a developer or if the user is undefined, otherwise true
 */
export const useIsDeveloper = () => {
    useSignals();
    const legacyIsDeveloper = useSelector((state) => (state.auth?.masqUser ?? state.auth?.user)?.isDeveloper);
    return useContainer().getOptional('CurrentUserModel')?.isDeveloper.value ?? legacyIsDeveloper ?? false;
};
